import 'slick-carousel';

function slider_mobile($slider, dots, arrows) {
	let $slides = $slider.find('.slider__slides');

	if ( dots == undefined ) {
		dots = false;
	}

	if ( arrows == undefined ) {
		arrows = false;
	}

	$slides.slick({
		dots: dots,
		arrows: arrows,
		slidesToShow: 5,
		slidesToScroll: 1,
		speed: 1000,
		centerMode: false,
		variableWidth: false,
		adaptiveHeight: false,
		fade: false,
		autoplay: false,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});
}

export default slider_mobile;
